import { useState } from 'react';
import MDBox from 'src/components/md/MDBox';
import Modal from 'src/components/modal/Modal';
import { TextField, SelectChangeEvent } from '@mui/material';
import useCreateWarehouse from 'src/api/inventory-management/useCreateWarehouse';

const CreateWarehouseModal: React.FC<{
  onClose: (refetch?: boolean) => void;
}> = ({ onClose }) => {
  const {
    mutate: createWarehouse,
    isLoading,
    error,
  } = useCreateWarehouse(() => {
    onClose(true);
  });

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    address: {
      street: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
    },
  });

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent,
  ) => {
    const { name, value } = e.target;
    if (name.startsWith('address.')) {
      const addressField = name.split('.')[1];
      setFormData((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          [addressField]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  return (
    <Modal
      open={true}
      title="Create Warehouse"
      closeable
      isLoading={isLoading}
      onConfirmButton={{
        text: 'Create',
        onClick: () => {
          createWarehouse(formData);
        },
        disabled: isLoading,
      }}
      onCloseButton={{ text: 'Cancel', onClick: onClose }}
      error={error}
    >
      <MDBox>
        <MDBox display="flex" flexDirection="column" gap={2} mt={2}>
          <TextField
            name="name"
            label="Name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            name="description"
            label="Description"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />
          <TextField
            name="address.street"
            label="Street Address"
            value={formData.address.street}
            onChange={handleChange}
            fullWidth
          />
          <MDBox display="flex" gap={2}>
            <TextField
              name="address.city"
              label="City"
              value={formData.address.city}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              name="address.state"
              label="State"
              value={formData.address.state}
              onChange={handleChange}
              fullWidth
            />
          </MDBox>
          <MDBox display="flex" gap={2}>
            <TextField
              name="address.zipCode"
              label="ZIP Code"
              value={formData.address.zipCode}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              name="address.country"
              label="Country"
              value={formData.address.country}
              onChange={handleChange}
              fullWidth
            />
          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
};

export default CreateWarehouseModal;
